import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import { ConnectionProvider } from './lib/connection';
import { ConsensusStatusProvider } from './lib/consensus-status';
import { VerifyPrefillProvider } from './lib/verify-prefill';
import { router } from './router';

export function App() {
  return (
    <AuthProvider>
      <ConnectionProvider>
        <ConsensusStatusProvider>
          <VerifyPrefillProvider>
            <RouterProvider router={router} />
          </VerifyPrefillProvider>
        </ConsensusStatusProvider>
      </ConnectionProvider>
    </AuthProvider>
  );
}
